module.exports = __webpack_public_path__ + "img/receipt.65f9be5c.svg";